import React, { Component } from "react";
import $ from 'jquery';
import InstructorToolTip from "./InstructorToolTip";


class HostStream extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			toolTipText: '',
			toolTipMsg: 0,
		}

	}
 
	componentDidMount(){
		
	}
	
	unMuteHost=()=>{
		$('#mic_control').trigger('click');
	}
	
	showToolTip=(num, mod)=>{
		this.setState({
			toolTipText: mod,
			toolTipMsg: num,
		});
	}
	
	hideToolTip=()=>{
		this.setState({
			toolTipText: '',
			toolTipMsg: 0,
		});
	}
	
	render() {
		return (
			<div className="host_stream_footer">
				<div className="myvideo_title">My Video</div>
				<div className="footer_video" id="host_video">
					<div className="host_mute_icon_holder d-none" id="host-muted-icon" onClick={this.unMuteHost} onMouseOver={e=>{this.showToolTip(1, 'Unmute microphone')}} onMouseLeave={this.hideToolTip} >
						{this.state.toolTipMsg == 1 &&	
							<InstructorToolTip
								state={this.state}
							></InstructorToolTip>
						}
					</div> 
				</div>
				<div className="footer_video d-none" id="host_injected_video">
					<video className="host_injected_video_element" src="" id="host_inj_video" type="video/mp4" autoplay></video>
				</div>
			</div>
	)}
}
export default HostStream;
